import React, { useState } from 'react';
import { Table, Button, Space, Tooltip } from 'antd';
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
} from '@ant-design/icons';
import { Link } from 'react-router-dom';
import DesignationModal from '../../../../components/modelpopup/DesignationModal';
import { useGetDesignationsQuery } from '../../../../services/settings.service';
import { DESIGNATIONS } from '../../../../services/ENDPOINTS';
import { useDispatch } from 'react-redux';
import { toggleDelete } from '../../../../redux/slices/ui.slice';

const Designations = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [editingDesignation, setEditingDesignation] = useState(null);
  const dispatch = useDispatch();

  // API Hooks
  const { data: designationsData, isLoading, refetch } = useGetDesignationsQuery();

  const designations = designationsData?.data || [];

  // Handle Add
  const handleAdd = () => {
    setEditingDesignation(null);
    setModalVisible(true);
  };

  // Handle Edit
  const handleEdit = (designation) => {
    setEditingDesignation(designation);
    setModalVisible(true);
  };

  // Handle Delete
  const doDelete = (e, item) => {
    dispatch(
      toggleDelete({
        open: true,
        title: 'Designation',
        url: `${DESIGNATIONS}/${item.id}`,
        ele: e.currentTarget,
        parent: 'tr'
      })
    );
  };

  // Table Columns
  const columns = [
    {
      title: '#',
      key: 'index',
      width: 60,
      render: (_, __, index) => index + 1,
    },
    {
      title: 'Designation Name',
      dataIndex: 'name',
      key: 'name',
      render: (text) => <span style={{ fontWeight: 500 }}>{text}</span>,
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: 'Department',
      dataIndex: 'departmentName',
      key: 'departmentName',
      render: (dept) => dept || <span style={{ color: '#888' }}>Not assigned</span>,
    },
    {
      title: 'Actions',
      key: 'actions',
      fixed: 'right',
      width: 120,
      render: (_, record) => (
        <Space size="small">
          <Tooltip title="Edit">
            <Button
              type="text"
              size="small"
              icon={<EditOutlined />}
              onClick={() => handleEdit(record)}
            />
          </Tooltip>
          <Tooltip title="Delete">
            <Button
              type="text"
              size="small"
              danger
              icon={<DeleteOutlined />}
              onClick={(e) => doDelete(e, record)}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Breadcrumb */}
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Designations</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/employee-dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Settings</li>
                </ul>
              </div>
              <div className="col-auto float-end ms-auto">
                <Link
                  to="#"
                  className="btn add-btn"
                  onClick={handleAdd}
                >
                  <i className="fa fa-plus" />
                  Add Designation
                </Link>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="table-responsive">
                

                  <Table
                    columns={columns}
                    dataSource={designations}
                    rowKey="id"
                    loading={isLoading}
                    pagination={{
                      pageSize: 10,
                      showSizeChanger: true,
                      showTotal: (total) => `Total ${total} designations`,
                    }}
                  />
                
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modals */}
      <DesignationModal
        visible={modalVisible}
        designation={editingDesignation}
        onClose={() => {
          setModalVisible(false);
          setEditingDesignation(null);
        }}
        onSuccess={() => {
          setModalVisible(false);
          setEditingDesignation(null);
          refetch();
        }}
      />
    </>
  );
};

export default Designations;
